import React from 'react';
import CommandIntelligenceIcon from './CommandIntelligenceIcon';
import { useThemeContext } from '../theme/ThemeProvider';

/**
 * Sidebar menu icon for Command Intelligence apps.
 * Reads connex theme context so palette and CSS hooks stay in sync with the shell.
 */
const CommandIntelligenceSidebarMenuIcon = props => {
  const { themeName } = useThemeContext();

  return (
    <CommandIntelligenceIcon {...props} size="sidebar" palette="sidebar" mode={themeName} />
  );
};

/** Pre-built element for connex-cds sidebar menu config (omit iconName when using this). */
export const commandIntelligenceSidebarMenuIcon = React.createElement(CommandIntelligenceSidebarMenuIcon);

export default CommandIntelligenceSidebarMenuIcon;
